import {
    afterNextRender,
    ChangeDetectionStrategy,
    Component,
    output,
} from '@angular/core';

@Component({
    selector: 'qpx-preview-renderer-load-error',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewRendererLoadError {
    public readonly loadError = output<Error>();

    public constructor() {
        afterNextRender(() => {
            this.loadError.emit(
                new Error('The document preview renderer failed to load.')
            );
        });
    }
}
